import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpInterface } from './http.interface';

@Injectable()
export class HttpService implements HttpInterface {
  constructor(private readonly http: HttpClient) {}
  get<T>(url: string): Observable<T> { return this.http.get<T>(environment.apiBaseUrl + url, { withCredentials: true }); }
  getBlob(url: string): Observable<Blob> { return this.http.get(environment.apiBaseUrl + url, { withCredentials: true, responseType: 'blob' }); }
  post<T>(url: string, body: unknown): Observable<T> { return this.http.post<T>(environment.apiBaseUrl + url, body, { withCredentials: true }); }
  postForm<T>(url: string, body: FormData): Observable<T> { return this.http.post<T>(environment.apiBaseUrl + url, body, { withCredentials: true }); }
}
